import { Action, Reducer } from "redux";
import { AppThunkAction } from ".";
import { Get } from "../api/apiUtils";
import { ApiCallModel } from "../models";
import { ActivitiesResult, ActivityLog } from "../models/ProcessFlowConfig";
import { PersistentDataService } from "../services/PersistentDataService";

export interface ActivityLogsState {
  activityLogs: ApiCallModel<ActivityLog[]>;
}

export const defaultState = {
  activityLogs: { isError: false, isLoading: false, result: undefined },
} as ActivityLogsState;

export interface GetActivityLogsAction {
  type: "GET_ACTIVITY_LOGS";
  payload: ApiCallModel<ActivityLog[]>;
}

type KnownAction = GetActivityLogsAction;

export const actionCreators = {
  getActivityLogs:
    (
      lineHandlingNo: string,
      success: (() => void) | undefined = undefined
    ): AppThunkAction<GetActivityLogsAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_ACTIVITY_LOGS",
        payload: {
          isLoading: true,
          isError: false,
          result: undefined,
        },
      });

      lineHandlingNo = lineHandlingNo.toLowerCase();
      Get(`api/v1.5/linehandling/${lineHandlingNo}/activities`, false)
        .then((result) => result.json())
        .then((result) => {
          dispatch({
            type: "GET_ACTIVITY_LOGS",
            payload: {
              isLoading: false,
              isError: false,
              result: (result as ActivitiesResult).activities,
            },
          });
          if (success) success();
        })
        .catch((reason) =>
          dispatch({
            type: "GET_ACTIVITY_LOGS",
            payload: {
              isLoading: false,
              isError: false,
              result: undefined,
            },
          })
        );
    },
  insertActivityLogs:
    (
      activityLogs: ActivityLog[],
      updated: ((actLogs: ActivityLog[]) => void) | undefined = undefined
    ): AppThunkAction<GetActivityLogsAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (
        state.activityLogs.activityLogs &&
        state.activityLogs.activityLogs.result
      ) {
        let lineHandlingNo = undefined;
        let currentActivityLogs = state.activityLogs.activityLogs.result;
        lineHandlingNo = currentActivityLogs[0].lineHandlingNo;
        let updatedActivities: number[] = [];

        for (let act of activityLogs) {
          const exist = currentActivityLogs.find((f) => f.id === act.id);
          if (exist) {
            updatedActivities = updatedActivities.concat(act.id);
            currentActivityLogs = [
              ...currentActivityLogs.filter((f) => f.id !== act.id),
              { ...exist, ...act },
            ];
          }
        }
        currentActivityLogs = currentActivityLogs.sort((a, b) =>
          a.id > b.id ? 1 : -1
        );

        const result = [
          ...currentActivityLogs,
          ...activityLogs.filter((f) => updatedActivities.indexOf(f.id) < 0),
        ];
        if (updated) updated(result);

        if (lineHandlingNo)
          PersistentDataService.saveActivityLogsAsync(lineHandlingNo, result);
        dispatch({
          type: "GET_ACTIVITY_LOGS",
          payload: {
            isError: false,
            isLoading: false,
            result,
          },
        });
      }
    },
  getActivityLogsByNomination:
    (
      nominationNo: string,
      success: (() => void) | undefined = undefined
    ): AppThunkAction<GetActivityLogsAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_ACTIVITY_LOGS",
        payload: {
          isLoading: true,
          isError: false,
          result: undefined,
        },
      });

      nominationNo = nominationNo.toLowerCase();
      Get(`api/v1.0/nomination/${nominationNo}/activities`, false)
        .then((result) => result.json())
        .then((result) => {
          dispatch({
            type: "GET_ACTIVITY_LOGS",
            payload: {
              isLoading: false,
              isError: false,
              result: (result as ActivitiesResult).activities,
            },
          });
          if (success) success();
        })
        .catch((reason) =>
          dispatch({
            type: "GET_ACTIVITY_LOGS",
            payload: {
              isLoading: false,
              isError: false,
              result: undefined,
            },
          })
        );
    },
};

export const reducers: Reducer<ActivityLogsState> = (
  state: ActivityLogsState | undefined,
  incomingAction: Action
): ActivityLogsState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "GET_ACTIVITY_LOGS":
      return { activityLogs: action.payload };
    default:
      return state;
  }
};
